<script lang="ts">
    import { onMount } from 'svelte';
    import CardList from './CardList.svelte';
    import { auth } from '../js/auth.js';
    import { api } from '../js/api.js';
    import type { TableData } from '../js/tableTypes.js';
    import type { ShoppingCart } from '../js/apiTypes.js';

    const tableData: TableData = {
        details: {
            titleList: 'Available token package for purchase',
            titleEdit: 'Product',
            create: false,
            hasMediaFiles: true,
            sortby: 'name',
        },
        fields: [
            {
                key: 'name',
                label: 'Name',
                type: 'text',
                editable: true,
                sortable: true,
            },
            {
                key: 'description',
                label: 'Description',
                type: 'text',
                editable: true,
                sortable: true,
            },
            {
                key: 'unit_price_inc_tax',
                label: 'Price Inc Tax',
                type: 'text',
                editable: true,
                sortable: true,
            },
        ],
        actions: [
            {
                label: 'Buy',
                action: 'buy',
                class: 'button-solid-link',
            },
        ],
    };

    onMount(async () => {
        if ($api.cart === null) {
            await api.getShoppingCart($auth.user.uuid);
        }
    });

    function handleBuyEvent(event: CustomEvent<{ item: { uuid: string }; srcElement: HTMLElement }>) {
        const id = event.detail.item.uuid;
        animateToCart(event.detail.srcElement);
        api.putShoppingCartLine($auth.user.uuid, id, getExistingItemQty(id) + 1);
    }

    function getExistingItemQty(itemUuid: string): number {
        const cart = $api.cart as ShoppingCart | null;
        if (!cart?.order_lines) return 0;
        for (const line of cart.order_lines) {
            if (line.item.uuid === itemUuid) {
                return line.quantity;
            }
        }
        return 0;
    }

    function animateToCart(srcElement: HTMLElement) {
        const cartIconElement = document.querySelector('#cart-icon');
        if (!cartIconElement) return;

        const giftIcon = document.createElement('i');
        giftIcon.className = 'fa fa-box';
        giftIcon.style.fontSize = '24px';
        giftIcon.style.color = '#000';
        giftIcon.style.opacity = '0.8';

        const srcRect = srcElement.getBoundingClientRect();
        const cartRect = cartIconElement.getBoundingClientRect();

        Object.assign(giftIcon.style, {
            position: 'absolute',
            top: `${srcRect.top}px`,
            left: `${srcRect.left}px`,
            transition: 'top 0.5s ease-in-out, left 0.5s ease-in-out, transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
            zIndex: '1000',
        });

        document.body.appendChild(giftIcon);

        giftIcon.offsetWidth;

        const scaleX = 1;
        const scaleY = 1;
        giftIcon.style.transform = `translate(${cartRect.left - srcRect.left}px, ${cartRect.top - srcRect.top}px) scale(${scaleX}, ${scaleY})`;
        giftIcon.style.opacity = '1';

        giftIcon.addEventListener('transitionend', () => {
            giftIcon.remove();
        });
    }
</script>

<CardList modelName="item" {tableData} on:buy={handleBuyEvent} enableSearch={false} />
<div class="ui hidden divider"></div>
